(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["helena-turnera"] && !Shopify.designMode) return;
  try {
    
class HelenaTurnera extends HTMLElement {
  connectedCallback() {
    if (this._init) return;

    // Portal al <body>: si el theme envuelve la seccion en un ancestro con
    // transform/filter/will-change (page transitions, etc.) se crea un
    // stacking context que atrapa el z-index del overlay; entonces popups o
    // menus del theme (Omnisend, mega-menu) quedan por encima y en desktop
    // no se puede clickear el formulario. Reubicandolo como hijo directo de
    // <body> el overlay compite en el contexto raiz y siempre queda arriba.
    // appendChild dispara disconnected+connected de forma sincronica; la
    // reinsercion vuelve a entrar aca ya como hijo de body y hace el init.
    if (this.parentElement && this.parentElement !== document.body) {
      // Si el Theme Editor re-renderizo la seccion, remover instancias
      // previas ya portadas al body para no duplicar el overlay.
      var hid = this.dataset.hel;
      document.querySelectorAll('helena-turnera[data-hel="' + hid + '"]').forEach(function (n) {
        if (n !== this && n.parentElement === document.body) n.remove();
      }, this);
      document.body.appendChild(this);
      return;
    }

    this._init = true;

    this.WD  = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
    this.WDF = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
    this.MO  = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    this.MOF = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

    // Config desde data-attributes. Las URLs de Make quedan visibles en el JS
    // publico (ver nota de seguridad arriba); Make valida token + payload.
    this.AVAIL_URL = (this.dataset.availabilityUrl || '').trim();
    this.RESERVE_URL = (this.dataset.reserveUrl || '').trim();
    this.TOKEN = (this.dataset.token || '').trim();
    this.CONSENT_LABEL = this.dataset.consentLabel || '';
    this.CONSENT_REQUIRED = this.dataset.consentRequired === 'true';
    // Offset fijo de Argentina (no DST). Fija el epoch de cada slot sin importar
    // la zona horaria del visitante.
    this.TZ_OFFSET = '-03:00';
    this.TIMEZONE = 'America/Argentina/Buenos_Aires';

    // status: idle | loading-availability | submitting-reservation | success | error
    this.state = { step: 'branch', dayIndex: 0, time: null, status: 'idle' };
    this._availReq = 0;         // token para descartar respuestas de availability viejas
    this._reservationId = null;

    this.stepOrder = ['branch', 'date', 'form', 'done'];
    this.stepItems = Array.from(this.querySelectorAll('.helena__step-item'));
    this.screens   = Array.from(this.querySelectorAll('.helena__screen'));
    this.daysEl    = this.querySelector('[data-days]');
    this.slotsEl   = this.querySelector('[data-slots]');
    this.subtitleEl = this.querySelector('.js-date-subtitle');
    this.availErrorEl = this.querySelector('.js-avail-error');
    this.reserveErrorEl = this.querySelector('.js-reserve-error');

    // Default selections come from the pre-marked first blocks.
    this.selectedBranch  = this.querySelector('.helena__branch.is-selected') || this.querySelector('[data-branch]');
    this.selectedService = this.querySelector('.helena__service.is-selected') || this.querySelector('[data-service]');
    if (this.selectedBranch)  this.selectedBranch.classList.add('is-selected');
    if (this.selectedService) this.selectedService.classList.add('is-selected');

    this.buildDays();
    this.selectDay(0);
    this.wireEvents();
    this.setStep('branch', true);
    this.updatePrimaryStates();

    this.lockScroll();
    this.suppressModalPopups();
  }

  disconnectedCallback() {
    // Durante el portal al body el elemento se remueve un instante sin haber
    // inicializado todavia (_init aun false): no desbloquear en ese caso.
    if (this._init) this.unlockScroll();
    if (this._popupObserver) { this._popupObserver.disconnect(); this._popupObserver = null; }
  }

  /* ── Suprimir popups modales ajenos (Omnisend, etc.) ──
     Este overlay es un takeover a pantalla completa. Un popup modal de otra
     app (ej: newsletter de Omnisend) usa aria-modal + un focus-trap: aunque
     helena quede pintada encima, el trap redirige el foco a SU input y el
     usuario no puede completar el formulario de reserva. Mientras el overlay
     esta abierto removemos cualquier modal ajeno apenas aparece.
     Nota: la solucion de fondo es excluir esta pagina en el panel de Omnisend;
     esto es una red de seguridad. */
  suppressModalPopups() {
    var self = this;
    var SEL = '[aria-modal="true"],[class*="omnisend-form"][class*="overlay"],[class*="omnisend-reset"],[class*="omnisend-form"][class*="-content"]';
    var kill = function () {
      document.querySelectorAll(SEL).forEach(function (n) {
        if (self === n || self.contains(n)) return; // nunca tocar el propio overlay
        // subir al contenedor raiz del popup (hijo directo de body) y removerlo
        var root = n;
        while (root.parentElement && root.parentElement !== document.body && !self.contains(root.parentElement)) {
          root = root.parentElement;
        }
        if (root && root !== document.body && !self.contains(root)) root.remove();
      });
    };
    kill();
    this._popupObserver = new MutationObserver(kill);
    this._popupObserver.observe(document.body, { childList: true, subtree: true });
  }

  /* ── Scroll lock (iOS-safe) ── */
  lockScroll() {
    this._prevBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }

  unlockScroll() {
    document.body.style.overflow = this._prevBodyOverflow || '';
  }

  /* ── Data ── */
  days() {
    const t = new Date(); t.setHours(0, 0, 0, 0);
    return Array.from({ length: 30 }, (_, i) => {
      const d = new Date(t); d.setDate(d.getDate() + i);
      return {
        i, date: d,
        dow: this.WD[d.getDay()], dnum: d.getDate(), mon: this.MO[d.getMonth()],
        full: `${this.WDF[d.getDay()]} ${d.getDate()} de ${this.MOF[d.getMonth()]}`
      };
    });
  }

  /* Slot engine: cadencia real de 25 min (15 servicio + 10 buffer), desde las
     11:00, con ultimo inicio 20:35 (20:35 + 15 + 10 = 21:00). Para cambiar
     horarios/cadencia se edita esta funcion en el liquid (Shopify admin). */
  slotTimes() {
    const OPEN = 11 * 60, CLOSE = 21 * 60, DUR = 15, BUF = 10, CAD = 25;
    const last = CLOSE - DUR - BUF;
    const out = [];
    for (let m = OPEN; m <= last; m += CAD) out.push(this.pad(Math.floor(m / 60)) + ':' + this.pad(m % 60));
    return out;
  }

  pad(n) { return String(n).padStart(2, '0'); }

  // Fecha local (YYYY-MM-DD) del dia seleccionado, para el payload.
  dateStr(sel) {
    const d = sel.date;
    return `${d.getFullYear()}-${this.pad(d.getMonth() + 1)}-${this.pad(d.getDate())}`;
  }

  // Epoch (ms) del inicio de un slot, fijado al offset de Argentina para que
  // no dependa de la zona horaria del navegador del visitante.
  slotEpoch(sel, time) {
    return Date.parse(`${this.dateStr(sel)}T${time}:00${this.TZ_OFFSET}`);
  }

  branchSlug() { return this.selectedBranch ? (this.selectedBranch.dataset.slug || '') : ''; }
  consentChecked() { const c = this.querySelector('[data-field="consent"]'); return !!(c && c.checked); }

/* ── Build days rail ── */
  buildDays() {
    this._days = this.days();
    this.daysEl.innerHTML = '';
    this._days.forEach((d) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'helena__day';
      b.dataset.dayIndex = d.i;
      b.innerHTML =
        `<span class="helena__day-dow">${d.dow}</span>` +
        `<span class="helena__day-num">${d.dnum}</span>` +
        `<span class="helena__day-mon">${d.mon}</span>`;
      b.addEventListener('click', () => this.selectDay(d.i));
      this.daysEl.appendChild(b);
    });
  }

  selectDay(index) {
    this.state.dayIndex = index;
    this.state.time = null;
    Array.from(this.daysEl.children).forEach((el) => {
      el.classList.toggle('is-selected', Number(el.dataset.dayIndex) === index);
    });
    // Si estamos en el paso de fecha, pedimos disponibilidad real; si no
    // (init en paso branch), pintamos una grilla local provisional.
    if (this.state.step === 'date') this.refreshAvailability();
    else this.renderSlots(this.fallbackGrid());
    this.updatePrimaryStates();
  }

  // Grilla local: aplica solo la anticipacion minima (1h). Se usa como fallback
  // en modo demo (sin URLs) o antes de la primera respuesta.
  fallbackGrid() {
    const sel = this._days[this.state.dayIndex] || this._days[0];
    const cutoff = Date.now() + 3600000;
    return this.slotTimes().map((t) => ({ time: t, available: this.slotEpoch(sel, t) >= cutoff }));
  }

  // Normaliza la respuesta de Make a una lista [{start,end}] (ISO strings).
  // Formato principal: { starts:"iso1,iso2", ends:"iso1,iso2" } (dos strings
  // paralelos separados por coma). Tambien acepta { busy:[{start,end}] } o el
  // shape de Google ({start:{dateTime},end:{dateTime}}) por compatibilidad.
  parseBusy(data) {
    if (data && typeof data.starts === 'string') {
      const starts = data.starts ? data.starts.split(',') : [];
      const ends = (typeof data.ends === 'string' && data.ends) ? data.ends.split(',') : [];
      return starts
        .map((s, i) => ({ start: s.trim(), end: (ends[i] || '').trim() }))
        .filter((x) => x.start && x.end);
    }
    return (data && (data.busy || data.events)) || [];
  }

  // Cruza la grilla contra los eventos ocupados que devuelve Make (Google
  // Calendar). Acepta [{start,end}] con ISO strings o el shape de Google
  // ({start:{dateTime},end:{dateTime}}). Aplica anticipacion minima + solape.
  computeBusyGrid(busyList) {
    const sel = this._days[this.state.dayIndex] || this._days[0];
    const cutoff = Date.now() + 3600000;
    const durMs = 15 * 60000;
    const busy = (busyList || [])
      .map((b) => {
        const s = Date.parse((b && b.start && b.start.dateTime) ? b.start.dateTime : b && b.start);
        const e = Date.parse((b && b.end && b.end.dateTime) ? b.end.dateTime : b && b.end);
        return { s, e };
      })
      .filter((x) => isFinite(x.s) && isFinite(x.e) && x.e > x.s);
    return this.slotTimes().map((t) => {
      const start = this.slotEpoch(sel, t);
      const end = start + durMs;
      let available = isFinite(start) && start >= cutoff;
      if (available) {
        for (const b of busy) { if (start < b.e && end > b.s) { available = false; break; } }
      }
      return { time: t, available };
    });
  }

  // Pinta los slots a partir de una lista [{time, available}].
  renderSlots(list) {
    this.slotsEl.innerHTML = '';
    let keepSelected = false;
    list.forEach(({ time, available }) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'helena__slot';
      b.textContent = time;
      b.disabled = !available;
      if (available && this.state.time === time) { b.classList.add('is-selected'); keepSelected = true; }
      if (available) {
        b.addEventListener('click', () => {
          this.state.time = time;
          Array.from(this.slotsEl.children).forEach((el) => el.classList.remove('is-selected'));
          b.classList.add('is-selected');
          this.updatePrimaryStates();
        });
      }
      this.slotsEl.appendChild(b);
    });
    // Si el horario elegido dejo de estar disponible, lo limpiamos.
    if (this.state.time && !keepSelected) this.state.time = null;
    this.updatePrimaryStates();
  }

  showSlotsLoading() {
    this.slotsEl.innerHTML = '<div class="helena__slots-msg"><span class="helena__spin" aria-hidden="true"></span>Cargando disponibilidad…</div>';
  }

  showAvailError() {
    this.slotsEl.innerHTML = '';
    if (this.availErrorEl) this.availErrorEl.hidden = false;
  }
  hideAvailError() { if (this.availErrorEl) this.availErrorEl.hidden = true; }

  showReserveError(msg) {
    if (!this.reserveErrorEl) return;
    this.reserveErrorEl.querySelector('.js-reserve-error-text').textContent = msg;
    this.reserveErrorEl.hidden = false;
  }
  hideReserveError() { if (this.reserveErrorEl) this.reserveErrorEl.hidden = true; }

  /* ── Disponibilidad real ── */
  async refreshAvailability() {
    const sel = this._days[this.state.dayIndex] || this._days[0];
    const slug = this.branchSlug();
    this.hideAvailError();

    // Modo demo: sin URL de disponibilidad (o sin slug) usamos la grilla local.
    if (!this.AVAIL_URL || !slug) { this.renderSlots(this.fallbackGrid()); return; }

    this.state.status = 'loading-availability';
    this.showSlotsLoading();
    const reqId = ++this._availReq;
    try {
      // Make maneja CORS/preflight automaticamente y parsea el JSON en campos.
      const res = await fetch(this.AVAIL_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ branch: slug, date: this.dateStr(sel), timezone: this.TIMEZONE, token: this.TOKEN })
      });
      if (reqId !== this._availReq) return; // llego una respuesta mas nueva
      if (!res.ok) throw new Error('AVAILABILITY_FAILED');
      const data = await res.json().catch(() => ({}));
      this.state.status = 'idle';
      this.renderSlots(this.computeBusyGrid(this.parseBusy(data)));
    } catch (e) {
      if (reqId !== this._availReq) return;
      this.state.status = 'error';
      this.showAvailError();
    }
  }

  /* ── Events ── */
  wireEvents() {
    this.querySelectorAll('[data-branch]').forEach((btn) => {
      btn.addEventListener('click', () => {
        this.querySelectorAll('[data-branch]').forEach((b) => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        this.selectedBranch = btn;
        // Si cambia la sucursal estando en el paso fecha, refrescar disponibilidad.
        if (this.state.step === 'date') this.refreshAvailability();
      });
    });
    this.querySelectorAll('[data-service]').forEach((btn) => {
      btn.addEventListener('click', () => {
        this.querySelectorAll('[data-service]').forEach((b) => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        this.selectedService = btn;
      });
    });
    this.querySelectorAll('.helena__input').forEach((inp) => {
      inp.addEventListener('input', () => { this.hideReserveError(); this.updatePrimaryStates(); });

      // iOS Safari: dentro de un overlay position:fixed, algunos iPhones no
      // enfocan el <input> al primer toque. Forzamos el foco dentro del propio
      // gesto (pointerup/touchend), que iOS si respeta para abrir el teclado.
      let sx = 0, sy = 0, moved = false;
      const onStart = (e) => {
        const p = e.touches ? e.touches[0] : e;
        sx = p.clientX; sy = p.clientY; moved = false;
      };
      const onMove = (e) => {
        const p = e.touches ? e.touches[0] : e;
        if (Math.abs(p.clientX - sx) > 10 || Math.abs(p.clientY - sy) > 10) moved = true;
      };
      const onEnd = () => {
        if (!moved && document.activeElement !== inp) {
          try { inp.focus(); } catch (err) {}
        }
      };
      inp.addEventListener('touchstart', onStart, { passive: true });
      inp.addEventListener('touchmove', onMove, { passive: true });
      inp.addEventListener('touchend', onEnd, { passive: true });
      inp.addEventListener('pointerup', onEnd);
    });
    const consent = this.querySelector('[data-field="consent"]');
    if (consent) consent.addEventListener('change', () => this.updatePrimaryStates());

    this.querySelectorAll('[data-action]').forEach((btn) => {
      btn.addEventListener('click', () => this.handleAction(btn.dataset.action));
    });
  }
handleAction(action) {
    switch (action) {
      case 'to-date':  this.setStep('date'); break;
      case 'to-form':  this.setStep('form'); break;
      case 'confirm':  this.submitReservation(); break;
      case 'back':     this.setStep(this.state.step === 'form' ? 'date' : 'branch'); break;
      case 'reset':    this.reset(); break;
      case 'retry-availability': this.refreshAvailability(); break;
      case 'add-to-calendar': this.addToCalendar(); break;
    }
  }

  /* ── Form validation ── */
  formData() {
    const get = (name) => (this.querySelector(`[data-field="${name}"]`)?.value || '').trim();
    return { nombre: get('nombre'), apellido: get('apellido'), email: get('email'), telefono: get('telefono') };
  }
  isFormValid() {
    const f = this.formData();
    const emailOk = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(f.email);
    const phoneDigits = f.telefono.replace(/[^\d]/g, '').length;
    const base = !!(f.nombre && f.apellido && emailOk && phoneDigits >= 6);
    if (this.CONSENT_REQUIRED && !this.consentChecked()) return false;
    return base;
  }

  updatePrimaryStates() {
    const branchBtn = this.querySelector('.helena__screen--branch [data-action="to-date"]');
    const dateBtn   = this.querySelector('.helena__screen--date [data-action="to-form"]');
    const formBtn   = this.querySelector('.helena__screen--form [data-action="confirm"]');
    if (branchBtn) branchBtn.disabled = !this.selectedBranch;
    if (dateBtn)   dateBtn.disabled = !this.state.time;
    // No re-habilitar el boton de confirmar mientras se esta enviando.
    if (formBtn && this.state.status !== 'submitting-reservation') formBtn.disabled = !this.isFormValid();
  }

  /* ── Step transitions ── */
  setStep(step, immediate) {
    this.state.step = step;
    this.setAttribute('data-step', step);
    const cur = this.stepOrder.indexOf(step);

    this.stepItems.forEach((item, i) => {
      const state = i === cur ? 'active' : (i < cur ? 'past' : 'upcoming');
      item.dataset.state = state;
      const dot = item.querySelector('.helena__step-dot');
      dot.textContent = state === 'past' ? '✓' : dot.dataset.num;
    });

    this.screens.forEach((sc) => {
      const active = sc.dataset.screen === step;
      sc.classList.remove('is-active');
      if (active) {
        if (!immediate) void sc.offsetWidth; // reflow to replay animation
        sc.classList.add('is-active');
      }
    });

    if (step === 'date') { this.updateDateSubtitle(); this.refreshAvailability(); }
    if (step === 'form') { this.hideReserveError(); this.fillSummaries(); }
    if (step === 'done')  this.fillSummaries();

    this.updatePrimaryStates();
    if (!immediate) {
      try { this.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { this.scrollTop = 0; }
    }
  }

  updateDateSubtitle() {
    const name = this.selectedBranch ? this.selectedBranch.dataset.name : '';
    this.subtitleEl.textContent = name ? `En nuestra sucursal ${name}` : '';
  }

  fillSummaries() {
    const sel = this._days[this.state.dayIndex] || this._days[0];
    const full = sel.full;
    const summaryDay = full.charAt(0).toUpperCase() + full.slice(1);
    const time = this.state.time || '';
    const branchName = this.selectedBranch ? this.selectedBranch.dataset.name : '';

    this.querySelectorAll('.js-summary-line').forEach((el) => {
      el.textContent = time ? `${summaryDay} · ${time} hs` : '';
    });
    this.querySelectorAll('.js-summary-branch').forEach((el) => { el.textContent = branchName; });
    this.querySelectorAll('.js-summary-day').forEach((el) => { el.textContent = summaryDay; });
    this.querySelectorAll('.js-summary-time').forEach((el) => { el.textContent = time ? `${time} hs` : ''; });
  }

  setButtonLoading(btn, on, text) {
    if (!btn) return;
    if (on) {
      if (!btn.dataset._label) btn.dataset._label = btn.textContent;
      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.innerHTML = '<span class="helena__spin" aria-hidden="true"></span>' + (text || btn.dataset._label);
    } else {
      btn.classList.remove('is-loading');
      btn.textContent = text || btn.dataset._label || '';
      this.updatePrimaryStates();
    }
  }

  /* ── Confirmar reserva (condicionada a OK del backend) ── */
  async submitReservation() {
    if (this.state.status === 'submitting-reservation') return; // evita doble click
    if (!this.isFormValid()) { this.showReserveError('Completá correctamente tus datos para continuar.'); return; }

    const btn = this.querySelector('.helena__screen--form [data-action="confirm"]');
    const sel = this._days[this.state.dayIndex] || this._days[0];
    const f = this.formData();
    this.hideReserveError();

    this._reservationId = (self.crypto && crypto.randomUUID) ? crypto.randomUUID() : ('r-' + Date.now() + '-' + Math.random().toString(16).slice(2));

    const branchName = this.selectedBranch ? this.selectedBranch.dataset.name : '';
    const payload = {
      reservationId: this._reservationId,
      branch: this.branchSlug(),
      branchLabel: branchName,
      date: this.dateStr(sel),
      time: this.state.time,
      timezone: this.TIMEZONE,
      durationMinutes: 15,
      bufferMinutes: 10,
      customer: { firstName: f.nombre, lastName: f.apellido, email: f.email, phone: f.telefono },
      consent: { acceptsComms: this.consentChecked(), label: this.CONSENT_LABEL },
      source: { pageUrl: location.href, platform: 'shopify', flow: 'helena-turnera' },
      token: this.TOKEN
    };

    // Modo demo: sin URL de reserva no hay persistencia; pasamos a done igual
    // para no romper la pagina durante el armado.
    if (!this.RESERVE_URL) { this.state.status = 'success'; this.setStep('done'); return; }

    this.state.status = 'submitting-reservation';
    this.setButtonLoading(btn, true, 'Confirmando…');
    try {
      // Make maneja CORS/preflight automaticamente y parsea el JSON en campos.
      const res = await fetch(this.RESERVE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await res.json().catch(() => ({}));

      if (data.code === 'SLOT_UNAVAILABLE') {
        this.state.status = 'error';
        this.setButtonLoading(btn, false);
        this.showReserveError('Ese horario ya no está disponible. Elegí otro turno.');
        this.setStep('date');
        this.refreshAvailability();
        return;
      }

      if (res.ok && data.ok !== false) {
        if (data.reservationId) this._reservationId = data.reservationId;
        this.state.status = 'success';
        this.setButtonLoading(btn, false);
        this.setStep('done');
        return;
      }

      if (data.code === 'BAD_REQUEST') {
        this.state.status = 'error';
        this.setButtonLoading(btn, false);
        this.showReserveError('Completá correctamente tus datos para continuar.');
        return;
      }

      throw new Error(data.code || 'RESERVATION_FAILED');
    } catch (e) {
      this.state.status = 'error';
      this.setButtonLoading(btn, false);
      this.showReserveError('No pudimos confirmar la reserva en este momento. Intentá nuevamente.');
    } finally {
      if (this.state.status !== 'success' && this.state.status !== 'submitting-reservation') {
        this.state.status = 'idle';
      }
    }
  }

  /* ── Reset ── */
  reset() {
    this.state.time = null;
    this.state.status = 'idle';
    this._reservationId = null;
    this.querySelectorAll('.helena__input').forEach((inp) => { inp.value = ''; });
    const consent = this.querySelector('[data-field="consent"]');
    if (consent) consent.checked = consent.defaultChecked;
    this.hideReserveError();
    this.selectDay(this.state.dayIndex);
    this.setStep('branch');
  }

  /* ── Google Calendar (cliente) ──
     Evento de 15 min reales. Titulo y descripcion segun brief. */
  addToCalendar() {
    const sel = this._days[this.state.dayIndex];
    if (!sel || !this.state.time) return;
    const [hh, mm] = this.state.time.split(':').map(Number);
    const start = new Date(sel.date); start.setHours(hh, mm, 0, 0);
    const end = new Date(start.getTime() + 15 * 60000);
    const fmt = (d) => `${d.getFullYear()}${this.pad(d.getMonth() + 1)}${this.pad(d.getDate())}T${this.pad(d.getHours())}${this.pad(d.getMinutes())}00`;

    const f = this.formData();
    const fullName = `${f.nombre} ${f.apellido}`.trim();
    const branchName = this.selectedBranch ? this.selectedBranch.dataset.name : '';
    const address = this.selectedBranch ? this.selectedBranch.dataset.address : '';
    const title = `Reserva experiencia Helena${fullName ? ' - ' + fullName : ''}`;
    const details = [
      'Reserva experiencia Helena', '',
      fullName ? `Cliente: ${fullName}` : '',
      f.email ? `Email: ${f.email}` : '',
      f.telefono ? `Telefono: ${f.telefono}` : '',
      branchName ? `Sucursal: ${branchName}` : '',
      `Hora: ${this.state.time}`,
      this._reservationId ? `Reservation ID: ${this._reservationId}` : ''
    ].filter(Boolean).join('\n');

    const params = new URLSearchParams({
      action: 'TEMPLATE',
      text: title,
      dates: `${fmt(start)}/${fmt(end)}`,
      details: details,
      location: address
    });
    window.open('https://calendar.google.com/calendar/render?' + params.toString(), '_blank');
  }
}

if (!customElements.get('helena-turnera')) {
  customElements.define('helena-turnera', HelenaTurnera);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
